import { useState } from 'react';
import { differenceInDays } from 'date-fns';

import { useCurrentUser, useLicenseExpires } from 'services/auth';
import { Callout } from 'components/common/Callout';
import { DAY_IN_YEAR_FORMAT } from 'consts/datetime';
import { formatInTimezone } from 'utils/datetime';

const CALLOUT_EXPIRY_DAYS = 30;

export function LicenseExpiryCallout() {
  const { user } = useCurrentUser();
  const licenseExpires = useLicenseExpires();
  const [hasClosedCallout, setHasClosedCallout] = useState(
    sessionStorage.getItem('hasClosedLicenseExpiryCallout') === 'true',
  );

  if (!licenseExpires || hasClosedCallout || !user) {
    return null;
  }

  const shouldShowCallout =
    differenceInDays(licenseExpires, new Date()) <= CALLOUT_EXPIRY_DAYS &&
    user?.permissions?.find((p) => p.name === 'Admin');

  if (!shouldShowCallout) {
    return null;
  }

  return (
    <Callout
      status="warning"
      onClose={() => {
        sessionStorage.setItem('hasClosedLicenseExpiryCallout', 'true');
        setHasClosedCallout(true);
      }}
    >
      Your MixMode subscription will expire on {formatInTimezone(licenseExpires, DAY_IN_YEAR_FORMAT)}. <br />
      Please reach out to{' '}
      <a href="mailto:support@mixmode.ai" className="text-[inherit] underline">
        support@mixmode.ai
      </a>
      .
    </Callout>
  );
}
